export default "__VITE_ASSET__o1lHrudt__"